import {API_AUTH_ROLE} from "../../const/Api";
import {RestApiMethod} from "../../const/dataEnum";
import {callAPI} from "./callApi";

const getAll = async () => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_AUTH_ROLE,
    });
    return res.data;
  } catch (error) {
    console.error('authRoleApi getAll Error:', error.message);
    return null;
  }
};

const authRoleApi = {
  getAll
}

export default authRoleApi;